import useModal from '../../use/useModal/useModal';
import SmsConfirmation from '../../components/Cabinet/EnterCabinet/SmsConfirmation.vue';
import SignInUpdate from '../../components/Cabinet/Entry/SignInPhoneUpdate/SignInUpdate.vue';

const modal = useModal();
export default {
  state: {
    data: {
      activeTab: 'enter',
      reCaptchaToken: '',
      chooseEnter: 'email',
      timer: 0,
      timeOut: null,
      btnValues: {
        registration: 'Зарегистрироваться',
        enter: 'Войти',
        codeSMS: 'Получить смс с кодом',
      },
    },
  },
  mutations: {
    'personal/setData'(store, payload) {
      try {
        store.data = {
          activeTab: store.data.activeTab,
          reCaptchaToken: store.data.reCaptchaToken,
          btnValues: store.data.btnValues,
          chooseEnter: store.data.chooseEnter,
          ...payload,
        };
      } catch (err) {
        console.error(err);
      }
    },
    'personal/updateData'(store, payload) {
      try {
        store.data = { ...store.data, [payload.name]: payload.data };
      } catch (err) {
        console.error(err);
      }
    },
    'personal/setError'(store, payload) {
      try {
        store.data = {
          ...store.data,
          errors: {
            ...payload,
          },
        };
      } catch (err) {
        console.error(err);
      }
    },
    'personal/setTimer'(store, payload) {
      try {
        store.data = {
          ...store.data,
          timer: payload,
        };
      } catch (err) {
        console.error(err);
      }
    },
    'personal/setTimeOut'(store, payload) {
      try {
        store.data = {
          ...store.data,
          timeOut: payload,
        };
      } catch (err) {
        console.error(err);
      }
    },
    'personal/changeActiveTab'(store, payload) {
      try {
        store.data = {
          ...store.data,
          activeTab: payload,
        };
        delete store.data.errors;
      } catch (err) {
        console.error(err);
      }
    },
    'personal/clearState'(store, payload) {
      try {
        store.data = {
          ...store.data,
          authInfo: {
            ...store.data.authInfo,
            errors: null,
            showSMS: false,
          },
          errors: null,
        };
      } catch (err) {
        console.error(err);
      }
    },
    'personal/setReCapchaToken'(store, payload) {
      try {
        store.data = {
          ...store.data,
          reCaptchaToken: payload,
        };
      } catch (err) {
        console.error(err);
      }
    },
    'personal/setEnter'(store, payload) {
      store.data = {
        ...store.data,
        chooseEnter: payload,
      };
      delete store.data.errors;
      delete store.data.authInfo.errors;

      // commit('personal/clearState')
    },
  },
  actions: {
    async 'personal/loginByPhone'({ state, commit }, payload) {
      try {
        const { activeTab, btnValues } = state.data;
        const { e, component, reCaptchaToken, resend } = payload;
        const data = new FormData(e.target);
        const {
          path,
          data: { action, api, LANGUAGE_ID },
        } = state.data?.routes?.send_sms_code;

        const phone = data.get('USER_LOGIN')?.replace(/[+| |(|)]/g, '');

        data.append('action', action);
        data.append('api', api);
        data.append('LANGUAGE_ID', LANGUAGE_ID);
        data.append('authType', activeTab);
        data.append('g-recaptcha-response', reCaptchaToken);

        data.set('USER_LOGIN', phone);
        data.append('phone_number', phone);

        const response = await axios.post(path, data);

        if (!resend) {
          if (!response.error && !response.data.error && response.status === 200) {
            // component.$parent.$emit('close');
            modal.show(
              SmsConfirmation,
              {
                activeTab,
                btnValues,
                e,
                userPhoneNumber: data.get('USER_LOGIN'),
                userName: data.get('USER_NAME'),
                userLastName: data.get('USER_LAST_NAME'),
              },
              { width: '440px' }
            );
          } else if (response.data.error) {
            commit('personal/setError', { loginBuyPhone: response.data.error });
          }
        } else {
          return response;
        }
      } catch (err) {
        console.error(err);
      }
    },
    async 'personal/loginByEmail'({ state, commit, dispatch }, payload) {
      try {
        // const e = payload;
        const { e, component, reCaptchaToken } = payload;
        const { routes } = state.data;
        const data = new FormData(e.target);
        const {
          path,
          data: { action, api, LANGUAGE_ID },
        } = routes?.auth;
        const email = data.get('USER_LOGIN');

        data.append('action', action);
        data.append('LANGUAGE_ID', LANGUAGE_ID);
        data.append('api', api);
        // data.append('g-recaptcha-response', reCaptchaToken);

        const response = await axios.post(path, data);
        console.log(response);
        if (response.status === 200 || response.statusText === 'OK') {
          commit('personal/updateData', { name: 'authInputs', data: response.data.authInputs });
          commit('personal/updateData', { name: 'authInfo', data: response.data.authInfo });
        }

        if (response.data.authInfo.status) {
          // await dispatch('personal/signInPhoneUpdate', { email, component });
          location.reload();
        }
      } catch (err) {
        console.error(err);
      }
    },
    async 'personal/registerByEmail'({ state, commit }, payload) {
      try {
        const { e, component, reCaptchaToken } = payload;
        const { actions, routes } = state.data;
        const data = new FormData(e.target);
        const path = actions?.register;
        const {
          data: { action, api, LANGUAGE_ID },
        } = routes?.register;

        data.append('action', action);
        data.append('api', api);
        data.append('USER_LOGIN', data.get('USER_EMAIL'));
        data.append('g-recaptcha-response', reCaptchaToken);
        data.append('LANGUAGE_ID', LANGUAGE_ID);
        const response = await axios.post(path, data);

        if (response.status === 200) {
          if (response.data.authInfo) {
            commit('personal/updateData', {
              name: 'regInputs',
              data: response.data.regInputs,
            });
            commit('personal/updateData', { name: 'authInfo', data: response.data.authInfo });
          }
          /**
           * Вывод ошибки
           */
          commit('personal/updateData', {
            name: 'errors',
            data: { incorrectEmail: response.data.exceptionError },
          });

          if (response.data.authInfo.status && response.data.authInfo.isAuthorized) {
            modal.hide();
            location.reload();
          }
        }
      } catch (err) {
        console.error(err);
      }
    },
    async 'personal/recaptcha'({ state, commit }, payload) {
      const { component } = payload;
      const { reCaptchaSiteKey } = state.data.authInfo;
      // (optional) Wait until recaptcha has been loaded.
      await component.$recaptchaLoaded();

      // Execute reCAPTCHA with action "login".
      const token = await component.$recaptcha(reCaptchaSiteKey);
      this.reCaptchaToken = token;

      commit('personal/setReCapchaToken', token);
      return token;
    },

    async 'personal/signInPhoneUpdate'({ state, rootState, commit, dispatch }, payload) {
      const { path, action, LANGUAGE_ID } = state.data?.routes?.getPhoneUpdateByEmail;
      const params = { action, LANGUAGE_ID, ...{ email: payload.email } };

      const { status, data: response } = await axios.post(path, params);

      if (status !== 200) throw `bad request response status: ${status}`;

      // console.log(response)
      if (response.status && response.result.user.id) {
        const closeModalError = rootState?.results?.messages?.entry?.closeModalError;
        modal.show(
          SignInUpdate,
          {
            response: response.result.user,
          },
          {
            width: '340px',
            backgroundClose: () => {
              commit('personal/setError', { closeModalError });
            },
          }
        );
      }
    },

    async 'personal/signInDoPhoneUpdate'({ state, commit, dispatch }, payload) {
      const { path, action, LANGUAGE_ID } = state.data?.routes?.updatePhoneByEmail;
      const params = { action, LANGUAGE_ID, ...payload.requestParams };
      // console.log(params);
      const { status, data: response } = await axios.post(path, params);

      // console.log(response)
      if (status !== 200) throw `bad request response status: ${status}`;

      return response;
    },

    async 'personal/confirmPhoneForUpdate'({ state, commit }, formData) {
      try {
        const { path, action, LANGUAGE_ID } = state.data.routes.smsProcessUserPhoneUpdate;

        formData.set('action', action);
        formData.set('LANGUAGE_ID', LANGUAGE_ID);

        commit('global/loaderStart');
        const { status, data } = await axios.post(path, formData);
        commit('global/loaderStop');
        if (status !== 200) throw `bad request response status: ${status}`;

        return data;
      } catch (err) {
        console.error(err);
      }
    },
  },
  getters: {
    'personal/getTimer': ({ data: { timer } }) => timer,
  },
};
